export default import.meta.ROLLDOWN_FILE_URL_ofY5jC19FGqQloXnUK9kgQ